import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/app/[locale]/online-bestellen-webshop/WebshopPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de7783b91b8a56/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de7783b91b8a56/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de7783b91b8a56/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8de7783b91b8a56/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8de7783b91b8a56/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8de7783b91b8a56/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
